<style scoped>
.mysql_tables .v-navigation-drawer > .v-list .v-list__tile {
    font-weight: normal !important;
}
.mysql_tables .tile {
    margin: 0px;
    border-radius: 4px;
}
.mysql_tables .tile:first-child {
    margin-top: 8px;
}
.mysql_tables .v-list__tile {
    height: 28px !important;
}
.mysql_tables .v-list__tile--active {
    background: #757575 !important;
    color: #fff !important;
}

.list-group {
    min-height: 20px;
}
.list-group-item:first-of-type {
    margin-top: -10px !important;
    padding-top: 20px;
    min-height: 74px;
    cursor: move;
    list-style-type: none;
}
.list-group-item {
    padding-top: 20px;
    min-height: 74px;
    cursor: move;
    list-style-type: none;
}
.list-group-item i {
    cursor: pointer;
}
</style>

<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-tooltip v-if="sql_form && sql_form.form_id != null">
                                <template slot="activator">
                                    <v-btn icon @mouseup.left="downloadBuilderZipFile()">
                                        <v-icon>download</v-icon>
                                    </v-btn>
                                </template>
                                Download Zip File
                            </bc-tooltip>
                            <bc-tooltip v-if="sql_form && sql_form.form_id != null">
                                <template slot="activator">
                                    <v-btn icon @mouseup.left="showReorder = !showReorder">
                                        <v-icon>low_priority</v-icon>
                                    </v-btn>
                                </template>
                                Reorder Fields
                            </bc-tooltip>
                            <bc-btn-add @invoke-method="invokeMethod($event)" action="addForm" permanent></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbRefresh(true)" permanent></bc-btn-refresh>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-container grid-list-xl>
                    <v-layout row :wrap="$bp.smallScreen">
                        <bc-search-list
                            :items="sql_forms"
                            :filter="searchFilter"
                            :selected_id="selected_form_id"
                            item-value="form_id"
                            item-text="name"
                            :clickMethod="selectForm"
                        ></bc-search-list>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md9 lg10 pb-0 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <v-card elevation="0" v-if="sql_form">
                                <v-card-text>
                                    <vue-perfect-scrollbar
                                        class="scroll-area"
                                        :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                    >
                                        <v-form ref="form_builder">
                                            <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                <v-flex xs12 sm6>
                                                    <bc-autocomplete
                                                        v-model="sql_form.primary_table_id"
                                                        label="Based on table *"
                                                        :items="sql_table_options"
                                                        item-text="table_name"
                                                        item-value="table_id"
                                                        :rules="ifValid('forms.primary_table_id')"
                                                        :append-icon="sql_form.form_id != null ? 'lock' : '$vuetify.icons.dropdown'"
                                                        :readonly="sql_form.form_id != null"
                                                    ></bc-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="sql_form.singular_obj"
                                                        label="Singular Obj"
                                                        :counter="showCounter(sql_form.singular_obj, 'form.singular_obj')"
                                                        :rules="ifValid('forms.singular_obj')"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="sql_form.name"
                                                        label="Form Name"
                                                        :counter="showCounter(form_builder.name, 'form.name')"
                                                        :rules="ifValid('forms.name')"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="sql_form.plural_obj"
                                                        label="Plural Obj"
                                                        :counter="showCounter(form_builder.plural_obj, 'form.plural_obj')"
                                                        :rules="ifValid('forms.plural_obj')"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="sql_form.endpoint"
                                                        label="Endpoint"
                                                        :counter="showCounter(form_builder.endpoint, 'form.endpoint')"
                                                        :rules="ifValid('forms.endpoint')"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <bc-select
                                                        v-model="sql_form.has_scope"
                                                        label="Has Scope"
                                                        :items="[
                                                            { value: '0', text: 'No' },
                                                            { value: '1', text: 'Yes' },
                                                        ]"
                                                        item-value="value"
                                                        item-text="text"
                                                        :rules="ifValid('forms.has_scope')"
                                                    ></bc-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <bc-autocomplete
                                                        v-model="sql_form.sub_form_id"
                                                        :label="$t('lang.sub_forms')"
                                                        :items="sql_forms"
                                                        item-text="name"
                                                        item-value="form_id"
                                                        clearable
                                                        :rules="ifValid('forms.sub_form_id')"
                                                    ></bc-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="sql_form.comments"
                                                        label="Comments"
                                                        :counter="showCounter(sql_form.comments, 'form.comments')"
                                                        :rules="ifValid('forms.comments')"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <div v-if="sql_form && sql_form.form_id">
                                                <v-data-table
                                                    :headers="headers"
                                                    :items="sql_form.sql_form_fields || []"
                                                    :no-data-text="$t('lang.no_data_available')"
                                                    hide-actions
                                                >
                                                    <template slot="headers" slot-scope="props">
                                                        <tr>
                                                            <th v-for="header in props.headers" :key="`header-${header.text}`" :width="header.width">
                                                                {{ header.text }}
                                                            </th>
                                                            <th style="width: 50px"></th>
                                                        </tr>
                                                    </template>
                                                    <template slot="items" slot-scope="props">
                                                        <tr>
                                                            <td class="px-2">
                                                                <v-text-field
                                                                    v-model="props.item.name"
                                                                    :counter="showCounter(props.item.name, 'form_field.name')"
                                                                    :rules="ifValid('forms.sql_form_fields.name')"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="px-2">
                                                                <v-text-field
                                                                    v-model="props.item.rules"
                                                                    :counter="showCounter(props.item.rules, 'form_field.rules')"
                                                                    :rules="ifValid('forms.sql_form_fields.rules')"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="px-2">
                                                                <v-text-field
                                                                    v-model="props.item.min_len"
                                                                    :counter="showCounter(props.item.min_len, 'form_field.min_len')"
                                                                    :rules="ifValid('forms.sql_form_fields.min_len')"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="px-2">
                                                                <v-text-field
                                                                    v-model="props.item.max_len"
                                                                    :counter="showCounter(props.item.max_len, 'form_field.max_len')"
                                                                    :rules="ifValid('forms.sql_form_fields.max_len')"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="px-2">
                                                                <bc-autocomplete
                                                                    v-model="props.item.input_type"
                                                                    :items="input_types"
                                                                    :rules="ifValid('forms.sql_form_fields.input_type')"
                                                                ></bc-autocomplete>
                                                            </td>
                                                            <td class="px-2">
                                                                <v-text-field
                                                                    v-model="props.item.default_value"
                                                                    :counter="showCounter(props.item.default_value, 'form_field.default_value')"
                                                                    :rules="ifValid('forms.sql_form_fields.default_value')"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="px-2">
                                                                <v-text-field
                                                                    v-model="props.item.comments"
                                                                    :counter="showCounter(props.item.comments, 'form_field.comments')"
                                                                    :rules="ifValid('forms.sql_form_fields.comments')"
                                                                ></v-text-field>
                                                            </td>
                                                            <td>
                                                                <v-btn icon @mouseup.left="deleteFormField(props.item.id)">
                                                                    <v-icon color="error">delete</v-icon>
                                                                </v-btn>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="props.index == (form_fields || []).length - 1" class="no-stripe no-hover">
                                                            <td colspan="8"></td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </div>
                                        </v-form>
                                    </vue-perfect-scrollbar>
                                </v-card-text>

                                <v-card-actions>
                                    <v-btn
                                        class="mt-auto ml-0 px-0"
                                        color="error"
                                        v-if="sql_form && sql_form.form_id"
                                        @mouseup.left="$refs.deleteFormDialog.openDialog()"
                                    >
                                        {{ $t("lang.delete") }}
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="success"
                                        @click="openAddField"
                                        v-if="sql_form && sql_form.form_id && sql_form.available_fields && sql_form.available_fields.length > 0"
                                        >{{ $t("lang.add_field") }}</v-btn
                                    >
                                    <v-btn @click="closeSqlForms" flat>{{ $t("lang.cancel") }}</v-btn>
                                    <v-btn color="success" @click="saveSqlForms">{{ $t("lang.save") }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>

            <!-- NEW FIELD DIALOG START -->
            <bc-dialog :value="new_form_field_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">Add New Field</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="new_form_field_dialog"
                            :dialog-status="new_form_field_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="new_form_field">
                            <v-container grid-list-form>
                                <v-layout row wrap v-if="!isUserDefined">
                                    <v-flex xs12 v-if="sql_form && sql_form.form_id">
                                        <bc-autocomplete
                                            :focus="new_form_field_dialog"
                                            v-model="new_form_field.field_id"
                                            label="New Field"
                                            :items="sql_form.available_fields || []"
                                            item-text="name"
                                            item-value="field_id"
                                            :rules="ifValid($r.required(true))"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-else>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="new_form_field_dialog"
                                            v-model="user_form_field.name"
                                            label="Name *"
                                            :counter="showCounter(user_form_field.name, 'form_field.name')"
                                            :rules="ifValid('forms.sql_form_fields.name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="user_form_field.input_type"
                                            label="Input Type *"
                                            :items="input_types"
                                            :rules="ifValid('forms.sql_form_fields.input_type')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="user_form_field.rules"
                                            label="Rules"
                                            :counter="showCounter(user_form_field.rules, 'form_field.rules')"
                                            :rules="ifValid('forms.sql_form_fields.rules')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="user_form_field.min_len"
                                            label="Min Length"
                                            :counter="showCounter(user_form_field.min_len, 'form_field.min_len')"
                                            :rules="ifValid('forms.sql_form_fields.min_len')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="user_form_field.max_len"
                                            label="Max Length"
                                            :counter="showCounter(user_form_field.max_len, 'form_field.max_len')"
                                            :rules="ifValid('forms.sql_form_fields.max_len')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="user_form_field.default_value"
                                            label="Default Value"
                                            :counter="showCounter(user_form_field.default_value, 'form_field.default_value')"
                                            :rules="ifValid('forms.sql_form_fields.default_value')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="user_form_field.comments"
                                            label="Comments"
                                            :counter="showCounter(user_form_field.comments, 'form_field.comments')"
                                            :rules="ifValid('forms.sql_form_fields.comments')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" @mouseup.left="isUserDefined = !isUserDefined">
                            {{ isUserDefined ? "Select Field" : "User Defined" }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="new_form_field_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="addFieldForm()">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <!-- NEW FIELD DIALOG END -->

            <delete-confirmation-dialog
                ref="deleteFormFieldDialog"
                :message="$t('lang.delete_form_field_message')"
                :heading="$t('lang.delete_form_field_heading')"
                @onConfirm="deleteForms(delete_id)"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="deleteFormDialog"
                :message="$t('lang.delete_form_message')"
                :heading="$t('lang.delete_form_heading')"
                @onConfirm="deleteForms(sql_form.form_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import draggable from "vuedraggable";
import app from "Main";

export default {
    components: {
        draggable,
    },
    data() {
        return {
            headers: [
                { text: this.$t("lang.name"), sortable: false, width: "20%" },
                { text: this.$t("lang.rules"), sortable: false, width: "20%" },
                { text: this.$t("lang.min_length"), sortable: false, width: "10%" },
                { text: this.$t("lang.max_length"), sortable: false, width: "10%" },
                { text: this.$t("lang.input_type"), sortable: false, width: "10%" },
                { text: this.$t("lang.default_value"), sortable: false, width: "10%" },
                { text: this.$t("lang.comments"), sortable: false, width: "20%" },
            ],
            searchFilter: "",
            form_id: null,
            selected_form_id: null,
            sql_form: null,
            delete_id: null,
            form_fields_position: [],
            form_builder: {
                tables: "",
                name: "",
                singular_obj: "",
                plural_obj: "",
                endpoint: "",
                has_scope: "0",
                comments: "",
                sub_form_id: "",
            },
            new_form_builder: {
                name: null,
                primary_table_id: null,
                singular_obj: null,
                plural_obj: null,
                endpoint: null,
                has_scope: "0",
                comments: null,
                sub_form_id: null,
            },
            user_form_field: {
                name: null,
                input_type: null,
                rules: null,
                min_len: null,
                max_len: null,
                default_value: null,
                comments: null,
            },
            new_form_field: {
                field_id: null,
            },
            new_form_field_dialog: false,
            dbRefresh: _.debounce(this.refresh, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbGenerateFormsData: _.debounce(this.generateFormsData, 1500, { maxWait: 1500, leading: true, trailing: false }),
            drag: false,
            showReorder: false,
            input_types: [
                "v-text-field",
                "v-textarea",
                "v-switch",
                "bc-autocomplete",
                "bc-select",
                "bc-combobox",
                "bc-date-picker",
                "bc-time-picker",
                "bc-password-input",
                "bc-phone-input",
            ],
            tables: null,
            forms_data_preview: null,
            settings: {
                maxScrollbarLength: 80,
            },
            isUserDefined: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));

        this.$store
            .dispatch("fetchForms", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.sql_forms) {
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "configuration", replace: true });
                }
            });
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));

        store
            .dispatch("fetchForms", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.sql_forms) {
                    next((vm) => {
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "configuration", replace: true });
                }
            });
    },
    mounted() {
        this.refresh();
        this.$store.commit("toggleMainMenu", false);
        this.finishLoader();
        this.$store.commit("validationOn");
    },
    computed: {
        ...mapState({
            rules_forms: (state) => state.forms.rules_forms,
            rules_form_field: (state) => state.validation.rules_form_field,
            sql_forms: (state) => state.forms.forms,
            forms: (state) => state.forms.forms,
            form: (state) => state.forms.form,
            form_fields: (state) => state.forms.form_fields,
            sql_table_options: (state) => state.sql_tables.sql_table_options,
        }),
        isActiveMenu() {
            return (form_id) => (form_id == this.selected_form_id ? true : false);
        },
        resultQuery() {
            if (this.searchFilter) {
                return this.sql_forms.filter((item) => {
                    return this.searchFilter
                        .toLowerCase()
                        .split(" ")
                        .every((v) => item.name.toLowerCase().includes(v));
                });
            } else {
                return this.forms;
            }
        },
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    methods: {
        ...mapActions(["fetchForms", "fetchForm", "saveForm", "deleteForm", "fetchSqlTables", "fetchFormDownload"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        async selectForm(item) {
            if (item) {
                this.startLoader();

                await this.fetchForm({
                    id: item.form_id,
                })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.sql_form) {
                            this.selected_form_id = item.form_id;
                            this.sql_form = this.assignObj2(data.sql_form, this.rules_forms);
                        } else {
                            this.selected_form_id = null;
                            this.sql_form = null;
                        }
                    })
                    .finally(() => this.finishLoader());
            }

            this.fetchSqlTables({ body: { options: 1 } }).then((data) => {
                if (typeof data !== "undefined" && data.sql_tables) {
                    this.finishLoader();
                }
            });
        },
        addForm() {
            this.selected_form_id = null;
            if (this.$refs.form_builder) this.$refs.form_builder.reset();
            this.sql_form = this.assignObj2(this.new_form_builder, this.rules_forms);
        },
        saveSqlForms() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_builder")) {
                    let body = this.prepForm(this.sql_form, this.rules_forms);

                    this.saveForm({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.sql_form) {
                            this.selected_form_id = data.sql_form.form_id;
                            this.sql_form = this.assignObj2(data.sql_form, this.rules_forms);

                            this.refresh(true);
                        }
                    });
                }
            });
        },
        deleteForms(id) {
            if (id) {
                this.deleteForm({
                    id: id,
                }).then((data) => {
                    if (data && data.code == "200") {
                        this.selected_form_id = null;
                        this.sql_form = null;

                        this.refresh(true);
                        this.$refs.deleteFormDialog.close();
                        this.validationOff();
                    }
                    this.toggleModalLoader(false);
                });
            }
        },
        closeSqlForms() {
            this.selected_form_id = null;
            this.sql_form = null;
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchForms({});
            }

            if (this.selected_form_id && force == true) {
                await this.fetchForm({
                    id: this.selected_form_id,
                })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.sql_form) {
                            this.sql_form = this.assignObj2(data.sql_form, this.rules_forms);
                        } else {
                            this.selected_form_id = null;
                            this.sql_form = null;
                        }
                    })
                    .finally(() => this.finishLoader());
            }
            if (this.sql_table_options.length == 0 || force == true) await this.fetchSqlTables({ body: { options: 1 } });

            this.finishLoader();
        },
        openAddField() {
            this.new_form_field_dialog = true;
        },
        addFieldForm() {
            if (!this.isUserDefined) {
                let row = this.sql_form.available_fields.find((item) => item.field_id == this.new_form_field.field_id);
                let index = this.sql_form.available_fields.map((item) => item.field_id).indexOf(this.new_form_field.field_id);

                if (!row) return;

                if (!this.sql_form.sql_form_fields) this.sql_form.sql_form_fields = [];

                this.sql_form.sql_form_fields.push(row);
                this.sql_form.available_fields.splice(index, 1);
            } else {
                if (!this.sql_form.sql_form_fields) this.sql_form.sql_form_fields = [];
                this.sql_form.sql_form_fields.push(this.user_form_field);
            }

            this.$refs.new_form_field.reset();
            this.new_form_field_dialog = false;
        },
        deleteFormField(id = null) {
            let index = this.sql_form.sql_form_fields.map((item) => item.id).indexOf(id);
            this.sql_form.sql_form_fields.splice(index, 1);
        },
        async downloadBuilderZipFile() {
            await this.fetchFormDownload({
                body: {
                    form_id: this.selected_form_id,
                    module_name: this.sql_form.name,
                    table_to_build: this.sql_form.tables,
                },
            })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        window.open(data.file_download, "_self");
                    }
                })
                .finally(() => this.finishLoader());
        },
        generateFormsData(id) {
            this.$store.commit("toggleModalLoader", true);
            this.forms_data_preview_dialog = true;

            this.$store
                .dispatch("fetchForms", {
                    url: `forms/${id}/builder`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined") {
                        this.forms_data_preview = data;
                    }
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
    },
};
</script>
